export const formatNumber = (number, dilimiter = ",") => {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${dilimiter}`)
}